<template>
<div class="chapter">
<div class="inner_page">
<h1 class="TOC-head">CONTENTS</h1>
<p class="TOC-FBMHD"><a href="#/Introduction">INTRODUCTION</a></p>
<h2 class="TOCCT"><a href="#/Chapter1">BUTTERCREAM BASICS</a></h2>
<p class="TOC-AHD"><a href="#/Chapter11">BASIC BUTTERCREAM RECIPE</a></p>
<p class="TOC-AHD"><a href="#/Chapter12">EQUIPMENT</a></p>
<p class="TOC-AHD"><a href="#/Chapter13">NOZZLES</a></p>
<p class="TOC-AHD"><a href="#/Chapter14">COLOURING</a></p>
<p class="TOC-AHD"><a href="#/Chapter15">COVERING CAKES</a></p>
<p class="TOC-AHD"><a href="#/Chapter16">FILLING A PIPING BAG</a></p>
<p class="TOC-AHD"><span href="#/Chapter17" title="Link target outside of Sample">PIPING ADVICE</span></p>
<p class="TOC-AHD"><span href="#/Chapter18" title="Link target outside of Sample">BASIC PETAL STROKES</span></p>
<h2 class="TOCCT"><span href="#/Chapter2" title="Link target outside of Sample">FLOWERS</span></h2>
<p class="TOC-AHD"><span href="#/Chapter21" title="Link target outside of Sample">WHITE</span></p>
<p class="TOC-AHD"><span href="#/Chapter211" title="Link target outside of Sample">PINK</span></p>
<p class="TOC-AHD"><span href="#/Chapter221" title="Link target outside of Sample">MAGENTA</span></p>
<p class="TOC-AHD"><span href="#/Chapter231" title="Link target outside of Sample">RED</span></p>
<p class="TOC-AHD"><span href="#/Chapter241" title="Link target outside of Sample">ORANGE</span></p>
<p class="TOC-AHD"><span href="#/Chapter251" title="Link target outside of Sample">YELLOW</span></p>
<p class="TOC-AHD"><span href="#/Chapter261" title="Link target outside of Sample">GREEN</span></p>
<p class="TOC-AHD"><span href="#/Chapter271" title="Link target outside of Sample">BLUE</span></p>
<p class="TOC-AHD"><span href="#/Chapter281" title="Link target outside of Sample">PURPLE</span></p>
<p class="TOC-AHD"><span href="#/Chapter291" title="Link target outside of Sample">VIOLET</span></p>
<h2 class="TOCCT"><span href="#/Chapter3" title="Link target outside of Sample">LEAVES</span></h2>
<h2 class="TOCCT">PROJECTS</h2>
<p class="TOC-AHD"><span href="#/Chapter31" title="Link target outside of Sample">CONTEMPORARY CAKE</span></p>
<p class="TOC-AHD"><span href="#/Chapter32" title="Link target outside of Sample">OPULENT CAKE</span></p>
<p class="TOC-AHD"><span href="#/Chapter33" title="Link target outside of Sample">OMBRE CAKE</span></p>
<p class="TOC-AHD"><span href="#/Chapter34" title="Link target outside of Sample">RUSTIC CAKE</span></p>
<p class="TOC-AHD"><span href="#/Chapter35" title="Link target outside of Sample">VINTAGE CAKE</span></p>
<p class="TOC-FBMHD"><span href="#/Suppliers" title="Link target outside of Sample">SUPPLIERS</span></p>
<p class="TOC-FBMHD"><span href="#/Acknowledgments" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="TOC-FBMHD"><span href="#/About_the_Authors" title="Link target outside of Sample">ABOUT THE AUTHORS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?07d38f5a